import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";

import Loading from "../../../components/Loading";
import LogCards from "../../../components/LogCards/LogCards";
import ProtectedRoute from "../../../components/ProtectedRoute";
import DataTable from "../../../components/Tables/tables";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class NewsPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      content: [],
      contentNew: [],
      newAulas: 0,
      newStatus: 0,
      Total: 0
    };
  }

  componentDidMount() {
    this.getLos();
    // this.isNew();
  }

  getLos = () => {
    this.setState({ loading: true });

    const filters = {
      type: 1,
      // word: this.state.filters.word,
      // segment: this.state.filters.segment && this.state.filters.segment.value,
      // discipline:
      //   this.state.filters.discipline && this.state.filters.discipline.value,
      // serie: this.state.filters.serie && this.state.filters.serie.value,
      // module:
      //   !this.state.ability_filter &&
      //   this.state.filters.module &&
      //   this.state.filters.module.value,
      // ability:
      //   this.state.ability_filter &&
      //   this.state.filters.ability &&
      //   this.state.filters.ability.value,
      content: true
    };
    axios
      .post(`${URL.api}content/los/listLosFilter`, filters, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ content: resp.data.data[0].content }, () => {
          // this.setState({ loading: false });
        });
        this.isNew();
      });
  };

  isNew = () => {
    const date = new Date();

    const currentYear = date.getFullYear();
    const currentMonth = date.getUTCMonth() + 1;

    this.state.content.map(item => {
      const createdAt = new Date(item.created_at);
      const updatedAt = new Date(item.updated_at);
      const createdYear = createdAt.getUTCFullYear();
      const createdMonth = createdAt.getUTCMonth() + 1;
      const createdDay = createdAt.getDay();
      const updatedYear = updatedAt.getUTCFullYear();
      const updatedMonth = updatedAt.getUTCMonth() + 1;
      const updatedDay = updatedAt.getDay();

      if (createdYear === currentYear && createdMonth >= currentMonth - 1) {
        item.status = "Novo";
        item.data = `${createdDay}/${createdMonth}/${createdYear}`;
        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ newAulas: this.state.newAulas + 1 });
        this.setState({
          // eslint-disable-next-line react/no-access-state-in-setstate
          contentNew: [...this.state.contentNew, item]
        });
      }
      if (updatedYear === currentYear && updatedMonth >= currentMonth - 1) {
        item.status = "Atualizado";
        item.data = `${updatedDay}/${updatedMonth}/${updatedYear}`;

        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ newStatus: this.state.newStatus + 1 });
        this.setState({
          // eslint-disable-next-line react/no-access-state-in-setstate
          contentNew: [...this.state.contentNew, item]
        });
      }
    });

    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ Total: this.state.newAulas + this.state.newStatus });

    this.setState({ loading: false });
  };

  render() {
    return (
      <>
        <LogCards
          newAulas={this.state.newAulas}
          newStatus={this.state.newStatus}
          Total={this.state.Total}
          loading={this.state.loading}
        />
        <div className="animated fadeIn">
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : (
            <Row>
              {this.state.contentNew ? (
                <div id="list">
                  <DataTable
                    list={this.state.contentNew}
                    path="/news/panel/"
                    title="Novidades"
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "name", denomination: "Nome" },
                      {
                        name: "ability_description",
                        denomination: "Descrição"
                      },
                      { name: "status", denomination: "Status" },
                      { name: "data", denomination: "Data" }
                    ]}
                    insert
                    delete={false}
                    insertAction={this.insertAction}
                    getSelected={this.getSelected}
                    action={false}
                    btnEdit={false}
                    btnView={false}
                    btnAllocate={false}
                    btnReport={false}
                    // allocateAction={this.allocateAction}
                    // reportAction={this.reportAction}
                    // deleteAction={this.deleteAction}
                  />
                </div>
              ) : (
                "Loading..."
              )}
            </Row>
          )}
          {/* <button onClick={this.sendList}>Criar</button> */}
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(mapStateToProps)(NewsPanel);
